import { UserActivityTrackCredentials } from "@plugins/user-activity-track/types.ts";
import UserActivityTrackApi from "@apis/user.activity.track.api.ts";
import store from "@plugins/store";
import DateTimeFormatter from "@utils/datetime.formatter";
import DateTimeUtils from "@utils/datetime.utils";

class UserActivityTrackCredential {
  credentials?: UserActivityTrackCredentials;
  isFetching = false;

  constructor() {}

  getCredentials(): UserActivityTrackCredentials {
    return this.credentials as UserActivityTrackCredentials;
  }

  fetchUserActivityTrackCredentials() {
    if (this.isFetching) return Promise.resolve(true);

    this.isFetching = true;
    return new Promise((resolve, reject) => {
      UserActivityTrackApi.fetchCredentials().then(
        (response) => {
          if (response.code !== "ok") {
            return reject(response.errorMap["0"]);
          }
          const responseData = response?.data;
          if (responseData) {
            this.credentials = responseData;
          }
          this.isFetching = false;
          resolve(true);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  async checkCredentialsExpiredState() {
    const serverTime = store.getters["app/serverTime"];
    const serverLocalDateTime = DateTimeFormatter.formatToLocalDateTime(serverTime);
    const momentNow = DateTimeUtils.convertLocalDateTimeToMoment(serverLocalDateTime);

    const expiryLocalDateTime = this.credentials?.expiryDateTime;
    const momentExpired = DateTimeUtils.convertLocalDateTimeToMoment(expiryLocalDateTime);
    if (momentNow.isSameOrAfter(momentExpired)) {
      console.log(`Credentials expired, refetch UserActivityTrackCredentials`);
      await this.fetchUserActivityTrackCredentials();
    }
  }
}

const userActivityTrackCredential = new UserActivityTrackCredential();

export { userActivityTrackCredential };
